<template>
  <div class="popup">
    <div class="popup-wrap">
      <div class="popup-bg" @click="closePopup()"></div>
      <div class="popup-container" :style="{ 'max-width': maxWidth + 'px' }">
        <div class="popup-top">
          <div class="popup-top__title">
            <slot name="prepend-icon"></slot>
            {{ title }}
          </div>
          <button class="popup-close" @click="closePopup()">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L11 11" stroke="white" stroke-width="2"/>
              <path d="M11 1L1 11" stroke="white" stroke-width="2"/>
            </svg>
          </button>
        </div>
        <div class="popup-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'popup-wrap',
  props: {
    title: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: Number,
      default: 840
    }
  },
  methods: {
    closePopup() {
      this.$emit('close-popup');
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/scss/vars";

.popup {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 50;
  overflow-y: auto;

  &-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(17, 17, 17, 0.5);
  }

  &-wrap {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    overflow-y: auto;
    padding: 20px;
  }

  &-container {
    width: 100%;
    background: #fff;
    position: relative;
    z-index: 2;
    box-shadow: 0px 20px 80px rgba(0, 0, 0, 0.5);
  }

  &-top {
    padding: 20px;
    width: 100%;
    background: $black;
    position: relative;

    &__title {
      width: 100%;
      max-width: 90%;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      color: $white;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      svg {
        margin-right: 10px;
        margin-bottom: 1px;
      }
    }
  }

  &-close {
    padding: 0;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 25px;
    font-size: 0;

    svg {
      height: 100%;
      object-fit: cover;
      width: 100%;
      color: $white;
    }
  }
}

@media screen and (max-width: 900px) {
  .popup-bg {
    position: fixed;
  }
  .popup-wrap {
    height: 100vh;
    padding-left: 15px;
    padding-right: 15px;
    display: block;
  }
  .popup-wrap {
    overflow-y: auto;
  }
  .popup-container {
    margin: 40px auto 50px;
  }
}

@media screen and (max-width: 425px) {
  .popup-top__title {
    font-size: 14px;
  }
  .popup-top {
    padding: 15px;
  }
}
</style>

